export default {
  title: "",
  subtitle: "Colombian Person Registration",
  path: "person_registration_co",
  paragraph: "In Colombia, the document_type will be put like “cc” (Cedula de Ciudadania - natural citizens, a 10-digit number) or “ce” (Cedula de Extranjeria - for foreign citizens, a 6 to 9-digit number). Below you can check a payload with initial required information. For other requirements depending on payment methods, check the table 'Information needed for registration (Person)'",
  request: {
    payload: {
      "person": {
        "document_number": "1037633286",
        "document_type": "cc",
        "social_name": "Pablo Castro",
        "fiscal_country": "Colombia"
      }
    },
    responses: {
      "data": {
        "updated_at": "2023-09-26T20:55:55.900000",
        "status": "approved",
        "social_name": "Pablo Castro",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "net_monthly_average_income": null,
        "inserted_at": "2023-07-20T13:33:08.286343",
        "id": "9fc9ad01-1b1f-466e-b50d-51cdc46fab8b",
        "fiscal_country": "Colombia",
        "email": null,
        "documents": [],
        "document_type": "cc",
        "document_number": "1037633286",
        "clearance_level": 1,
        "birth_date": null,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonRegistrationCO.js